<template>
  <div>
    <div
      v-if="deploymentOnProd.chartData"
      style="width: 100%; display: flex; justify-content: flex-end;"
    >
      <div>
        <div style="color: #838ea0; font-weight: bold; text-align: end;">
          Choose date
        </div>
        <date-picker
          class="datePicker"
          v-model="dateRange"
          range-separator="~"
          range
          editable
          confirm
          confirm-text="Apply"
        >
        </date-picker>
      </div>
    </div>
    <div>
      <div v-if="deploymentOnProd.chartData" class="dep-gr">
        <div class="child1">
          <h2>Deployment Frequency / Month</h2>
          <div style="width: 100% !important; height: 100% !important;">
            <BarChart
              :chart-data="deploymentOnProd.chartData"
              :chart-options="deploymentOnProd.chartOptions"
            />
          </div>
        </div>
      </div>
      <div
        v-else
        class="rot-img"
        style="display: flex; justify-content: center;"
      >
        <img
          style="width: 80px; height: 80px;"
          src="@/assets/reload-icon.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import BarChart from '@/components/Metrics/BarChart.vue';
import MetricsConst from '@/views/Metrics/common/MetricsConst.js';
import { getMaxMonth, sliceChartData } from '@/views/Metrics/common/utils.js';
import 'vue2-datepicker/index.css';

export default {
  components: {
    DatePicker,
    BarChart
  },
  data() {
    return {
      dateRange: null,
      deploymentOnProd: {
        deploymentProdData: null,
        chartData: null,
        chartOptions: null,
        labels: null,
        datasets: null,
        timer: null,
        maxMonth: 0
      },
      MetricsConst: MetricsConst
    };
  },
  props: ['releasesOnProdData', 'fontSize'],
  methods: {
    renderDeploymentData: async function(
      _releasesOnProdData = this.releasesOnProdData
    ) {
      try {
        let releasesOnProdData = _releasesOnProdData;
        this.maxMonth = 0;
        this.deploymentOnProd.deploymentProdData = {};
        //releaseName is the date of deploymemnt
        for (let releaseOnProdData of releasesOnProdData) {
          if (
            !(
              releaseOnProdData.releaseName in
              this.deploymentOnProd.deploymentProdData
            )
          ) {
            this.deploymentOnProd.deploymentProdData[
              releaseOnProdData.releaseName
            ] = {};
          }
          let divisionCounter = this.deploymentOnProd.deploymentProdData[
            releaseOnProdData.releaseName
          ][releaseOnProdData.division];
          this.deploymentOnProd.deploymentProdData[
            releaseOnProdData.releaseName
          ][releaseOnProdData.division] = isNaN(divisionCounter)
            ? 1
            : divisionCounter + 1;
        }
        this.maxMonth = getMaxMonth(this.deploymentOnProd);
        const deploymentOnProdData = {
          [this.MetricsConst._FSH]: {
            type: 'bar',
            backgroundColor: this.MetricsConst.COLORS[this.MetricsConst._FSH],
            data: []
          },
          [this.MetricsConst._FBP]: {
            type: 'bar',
            backgroundColor: this.MetricsConst.COLORS[this.MetricsConst._FBP],
            data: []
          },
          [this.MetricsConst._3DIV]: {
            type: 'bar',
            backgroundColor: this.MetricsConst.COLORS[this.MetricsConst._3DIV],
            data: []
          },
          [this.MetricsConst._WFJ]: {
            type: 'bar',
            backgroundColor: this.MetricsConst.COLORS[this.MetricsConst._WFJ],
            data: []
          },
          [this.MetricsConst._MEITU]: {
            type: 'bar',
            backgroundColor: this.MetricsConst.COLORS[this.MetricsConst._MEITU],
            data: []
          },
          [this.MetricsConst._TOTAL_MONTHS]: {
            type: 'line',
            backgroundColor: this.MetricsConst.COLORS[
              this.MetricsConst._TOTAL_MONTHS
            ],
            data: []
          }
        };
        for (let releaseDate of Object.keys(
          this.deploymentOnProd.deploymentProdData
        )) {
          for (let divisionName of Object.keys(
            this.deploymentOnProd.deploymentProdData[releaseDate]
          )) {
            deploymentOnProdData[divisionName]?.data.push(
              this.deploymentOnProd.deploymentProdData[releaseDate][
                divisionName
              ]
            );
          }
        }
        this.deploymentOnProd.datasets = [];
        this.deploymentOnProd.labels = Object.keys(
          this.deploymentOnProd.deploymentProdData
        );
        for (let divisionName of Object.keys(deploymentOnProdData)) {
          this.deploymentOnProd.datasets.push({
            type: deploymentOnProdData[divisionName].type,
            label: divisionName,
            data: deploymentOnProdData[divisionName].data,
            backgroundColor: deploymentOnProdData[divisionName].backgroundColor,
            datalabels: {
              anchor: 'end',
              align: 'end',
              font: {
                size: 18,
                family: 'Verdana'
              },
              color: 'rgba(0, 0, 0, 0.7)',
              formatter: function(value) {
                return value === 0 ? '' : value;
              }
            },
            borderColor: deploymentOnProdData[divisionName].backgroundColor,
            borderWidth: 1,
            pointStyle: 'rectRot',
            pointRadius: 5,
            pointBorderColor: 'rgb(0, 0, 0)'
          });
          if (deploymentOnProdData[divisionName].type === 'line') {
            this.deploymentOnProd.datasets[
              this.deploymentOnProd.datasets.length - 1
            ].borderColor = '#fcbf49';
          }
        }
        this.deploymentOnProd.chartData = {
          datasets: this.deploymentOnProd.datasets,
          labels: this.deploymentOnProd.labels
        };
        this.deploymentOnProd.chartOptions = {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: {
              ticks: {
                font: {
                  size: 15,
                  family: 'Verdana'
                }
              }
            },
            y: {
              ticks: {
                font: {
                  size: 15,
                  family: 'Verdana'
                }
              },
              beginAtZero: true,
              max: this.maxMonth + 4
            }
          },
          plugins: {
            title: {
              display: true,
              text: '',
              font: {
                size: 20,
                family: 'Verdana'
              }
            },
            legend: {
              labels: {
                usePointStyle: true,
                font: {
                  size: 14,
                  family: 'Verdana'
                }
              },
              position: 'bottom'
            }
          },
          onHover: (e, elements) => {
            if (elements == null || elements.length === 0) {
              return;
            }
            let datasetIndex = elements[0]?.datasetIndex;
            for (let i = 0; i < this.deploymentOnProd.datasets.length; ++i) {
              if (i === datasetIndex) {
                this.deploymentOnProd.datasets[i].datalabels.color =
                  'rgb(0, 0, 0, 0.6)';
              } else {
                this.deploymentOnProd.datasets[i].datalabels.color =
                  'rgb(0, 0, 0, 0)';
              }
            }
            this.deploymentOnProd.timer = setTimeout(() => {
              for (let i = 0; i < this.deploymentOnProd.datasets.length; ++i) {
                this.deploymentOnProd.datasets[i].datalabels.color =
                  'rgb(0, 0, 0, 0.6)';
              }
            }, 100);
          }
        };
      } catch (err) {
        console.log(err);
      }
    }
  },
  watch: {
    dateRange: function() {
      if (
        this.dateRange === null ||
        this.dateRange[0] === null ||
        this.dateRange[1] === null
      ) {
        this.renderDeploymentData();
        return;
      }
      this.renderDeploymentData(
        sliceChartData(this.releasesOnProdData, this.dateRange)
      );
    },
    fontSize: function() {
      this.deploymentOnProd.chartData.datasets.forEach(element => {
        element.datalabels.font.size = this.fontSize;
      });
    }
  },
  mounted: async function() {
    await this.renderDeploymentData(this.releasesOnProdData);
  }
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@800');
.dep-gr {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  width: 100%;
}
.child1 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  width: 100%;
}
.dep-gr .child1 {
  padding: 30px 50px;
  border-radius: 2px;
  box-shadow: rgba(0, 0, 0, 0.16) 0 1px 4px;
  margin-top: 30px;
}
.dep-gr h2 {
  font-family: 'Nunito Sans', sans-serif;
  opacity: 0.8;
}

.datePicker {
  margin-bottom: 30px;
}
</style>
